// import external modules
import React from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import "../assets/css/appStyle.scss";
import "react-interactive-tutorials/dist/react-interactive-tutorials.css"
// import internal(own) modules
import Router from "./router";
import { GoogleOAuthProvider } from '@react-oauth/google';

const App = props => <GoogleOAuthProvider clientId="251804158029-nvou9fhfe6ahis1nuaef4ur6pde40sfb.apps.googleusercontent.com"><Router /></GoogleOAuthProvider>;

export default App;
